// extracted by mini-css-extract-plugin
module.exports = {"imgTextM":"ImgTextM_imgTextM__7pL1c"};